module.exports = __webpack_public_path__ + "img/maintop.f305d4c.png";